import { LLD_INFO, SWIFT_MESSAGE_INPUT_MAX_CHARS } from 'settings/constants/transfer/swift';
import {
  FIELD_TYPE_TEXT,
  EMAIL_MAX_CHARS,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_SELECT,
  FORMAT_ALPHANUMERIC,
  FIELD_TYPE_ACCORDION,
  FORMAT_BENEFICIARY_NAME,
  FIELD_TYPE_AUTOCOMPLETE,
  FIELD_TYPE_SECTION_HEADER,
  FORMAT_FAVOURITE_NICKNAME,
  FORMAT_ALPHABET_WITH_SPACE,
  DEFAULT_MIN_TRANSFER_AMOUNT,
  DEFAULT_MAX_TRANSFER_AMOUNT,
  FAVOURITE_NICKNAME_MAX_LENGTH,
  BENEFICIARY_ADDRESS_MAX_LENGTH,
  SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
  FORMAT_BENEFICIARY_MESSAGE,
  DEFAULT_TEXTFIELD_MIN_CHAR,
} from 'settings/constants/transaction';

export const SWIFT_FORM_FIELDS = [
  {
    name: 'accountNumber',
    label: 'transaction.transfer.swift.modal.accountTitle',
    type: FIELD_TYPE_TEXT,
    hasToolTip: true,
    toolTipTitle: 'transaction.transfer.swift.modal.tooltip',
    format: FORMAT_ALPHANUMERIC,
    validationRules: [
      { type: 'required', isValidateRequired: true },
      { type: 'accountLength', isValidateRequired: true },
      { type: 'validIBAN', isValidateRequired: true },
    ],
  },
  {
    name: 'transferAmount',
    label: 'transaction.transfer.transactionAmount',
    type: FIELD_TYPE_NUMBER,
    hasOption: true,
    optionField: {
      options: [],
      name: 'currency',
      // NOTE: validationRules are inside utils\transfer\swift\getter because it was getting overridden by the utils
    },
    validationRules: [
      { type: 'minAmount', value: DEFAULT_MIN_TRANSFER_AMOUNT, isValidateRequired: true },
      { type: 'maxAmount', value: DEFAULT_MAX_TRANSFER_AMOUNT, isValidateRequired: true },
      { type: 'required', isValidateRequired: true },
    ],
  },
  {
    name: 'transactionCharges',
    label: 'transaction.transfer.transactionCharges',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_SELECT,
    options: [],
    className: 'mb3',
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    name: 'beneficiaryBank',
    type: FIELD_TYPE_ACCORDION,
    defaultExpanded: true,
    title: 'transaction.transfer.beneficiary.bank',
    fields: [
      {
        name: 'beneficiaryBankSwiftCode',
        label: 'transaction.transfer.beneficiary.swiftCode',
        type: FIELD_TYPE_TEXT,
        readOnly: true,
      },
      {
        name: 'beneficiaryBankName',
        label: 'transaction.transfer.beneficiary.bank',
        type: FIELD_TYPE_TEXT,
        readOnly: true,
      },
      {
        name: 'beneficiaryBankAddress1',
        label: 'transaction.transfer.beneficiary.bankAddress',
        type: FIELD_TYPE_TEXT,
        readOnly: true,
      },
      {
        // NOTE: No label for this field
        name: 'beneficiaryBankAddress2',
        label: '',
        type: FIELD_TYPE_TEXT,
        readOnly: true,
      },
      {
        name: 'beneficiaryBankCountry',
        label: 'transaction.transfer.beneficiary.bankCountry',
        type: FIELD_TYPE_TEXT,
        readOnly: true,
        className: 'mb3',
      },
    ],
  },
  {
    name: 'beneficiaryInfo',
    type: FIELD_TYPE_ACCORDION,
    defaultExpanded: true,
    title: 'transaction.transfer.beneficiary.info',
    fields: [
      // NOTE: all fields is inside utils\transfer\swift\getter because new field will be concat to the front
      // this is a workaround for a transfer from favourite list because these fields will turn readOnly
    ],
  },
];

export const SWIFT_LLD_FIELDS = formatMessage => [
  {
    label: 'transaction.transfer.swift.lld.label',
    type: FIELD_TYPE_SECTION_HEADER,
  },
  {
    isDisablePortal: false,
    name: 'lldIdentityStatus',
    label: 'transaction.transfer.swift.lld.identityStatus.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    options: LLD_INFO(formatMessage).identityStatuses,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    name: 'lldCitizenship',
    label: 'transaction.transfer.swift.lld.citizenship.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    options: LLD_INFO(formatMessage).countries,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    name: 'lldBeneficiary',
    label: 'transaction.transfer.swift.lld.beneficiary.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    options: LLD_INFO(formatMessage).beneficiaries,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    name: 'lldRelationship',
    label: 'transaction.transfer.swift.lld.relationship.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    options: LLD_INFO(formatMessage).relationships,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    name: 'lldPurpose',
    label: 'transaction.transfer.swift.lld.purpose.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    options: LLD_INFO(formatMessage).purposes,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    options: [],
    name: 'lldDescription',
    label: 'transaction.transfer.swift.lld.description.label',
    placeholder: 'transaction.transfer.swift.placeholder.select',
    type: FIELD_TYPE_AUTOCOMPLETE,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    isDisablePortal: false,
    initialValue: '',
    name: 'lldMessage',
    label: 'transaction.transfer.swift.lld.message.label',
    placeholder: 'transaction.transfer.swift.lld.message.placeholder',
    format: FORMAT_BENEFICIARY_MESSAGE,
    type: FIELD_TYPE_TEXT,
    minLength: DEFAULT_TEXTFIELD_MIN_CHAR,
    maxLength: SWIFT_MESSAGE_INPUT_MAX_CHARS,
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
];

export const SWIFT_NEW_FAVOURITE = [
  {
    name: 'accountNickname',
    label: 'transaction.favourite.form.beneficiaryNickname',
    type: FIELD_TYPE_TEXT,
    format: FORMAT_FAVOURITE_NICKNAME,
    maxLength: FAVOURITE_NICKNAME_MAX_LENGTH,
    validationRules: [{ type: 'required' }, { type: 'validNickname' }],
  },
  {
    readOnly: true,
    name: 'bankSwiftCode',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.swiftCode',
  },
  {
    readOnly: true,
    name: 'bankName',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.bank',
  },
  {
    readOnly: true,
    name: 'bankAddress1',
    type: FIELD_TYPE_TEXT,
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    label: 'transaction.transfer.beneficiary.bankAddress',
  },
  {
    readOnly: true,
    name: 'bankAddress2',
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    type: FIELD_TYPE_TEXT,
  },
  {
    readOnly: true,
    name: 'bankCountryName',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.bankCountry',
  },
  {
    name: 'toAccountNo',
    label: 'transaction.transfer.swift.modal.accountTitle',
    type: FIELD_TYPE_TEXT,
    hasToolTip: true,
    toolTipTitle: 'transaction.transfer.swift.modal.tooltip',
    format: FORMAT_ALPHANUMERIC,
    validationRules: [
      { type: 'required', isValidateRequired: true },
      { type: 'accountLength', isValidateRequired: true },
      { type: 'validIBAN', isValidateRequired: true },
    ],
  },
  {
    type: FIELD_TYPE_TEXT,
    name: 'accountHolderName',
    label: 'transaction.transfer.beneficiary.name',
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    name: 'address1',
    label: 'transaction.transfer.beneficiary.address',
    type: FIELD_TYPE_TEXT,
    format: FORMAT_BENEFICIARY_NAME,
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    placeholder: 'transaction.transfer.swift.placeholder.street',
    validationRules: [{ type: 'required', isValidateRequired: true }],
  },
  {
    name: 'address2',
    type: FIELD_TYPE_TEXT,
    format: FORMAT_BENEFICIARY_NAME,
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    placeholder: 'transaction.transfer.swift.placeholder.other',
  },
  {
    name: 'address3',
    type: FIELD_TYPE_TEXT,
    format: FORMAT_ALPHABET_WITH_SPACE,
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    placeholder: 'transaction.transfer.swift.placeholder.country',
  },
  {
    name: 'emailAddress',
    label: 'transaction.transfer.beneficiary.emailOptional',
    type: FIELD_TYPE_TEXT,
    maxLength: EMAIL_MAX_CHARS,
    validationRules: [{ type: 'validEmail', isValidateRequired: true }],
  },
];

export const SWIFT_EDIT_FAVOURITE = [
  {
    name: 'accountNickname',
    label: 'transaction.favourite.form.beneficiaryNickname',
    type: FIELD_TYPE_TEXT,
    format: FORMAT_FAVOURITE_NICKNAME,
    maxLength: FAVOURITE_NICKNAME_MAX_LENGTH,
    validationRules: [{ type: 'required' }, { type: 'validNickname' }],
  },
  {
    readOnly: true,
    name: 'bankSwiftCode',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.swiftCode',
  },
  {
    readOnly: true,
    name: 'bankName',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.bank',
  },
  {
    readOnly: true,
    name: 'bankAddress1',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.bankAddress',
  },
  {
    readOnly: true,
    name: 'bankAddress2',
    type: FIELD_TYPE_TEXT,
  },
  {
    readOnly: true,
    name: 'bankCountryName',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.bankCountry',
  },
  {
    readOnly: true,
    hasToolTip: true,
    name: 'toAccountNo',
    type: FIELD_TYPE_TEXT,
    toolTipTitle: 'transaction.transfer.swift.modal.tooltip',
    label: 'transaction.transfer.swift.modal.accountTitle',
  },
  {
    readOnly: true,
    name: 'accountHolderName',
    type: FIELD_TYPE_TEXT,
    label: 'transaction.transfer.beneficiary.name',
  },
  {
    readOnly: true,
    name: 'address1',
    type: FIELD_TYPE_TEXT,
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    label: 'transaction.transfer.beneficiary.address',
  },
  {
    readOnly: true,
    name: 'address2',
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    type: FIELD_TYPE_TEXT,
  },
  {
    readOnly: true,
    name: 'address3',
    maxLength: SWIFT_FAVOURITE_MAX_ADDRESS_LENGTH,
    type: FIELD_TYPE_TEXT,
  },
  {
    name: 'emailAddress',
    label: 'transaction.transfer.beneficiary.emailOptional',
    type: FIELD_TYPE_TEXT,
    maxLength: EMAIL_MAX_CHARS,
    validationRules: [{ type: 'validEmail', isValidateRequired: true }],
  },
];
